import React, {Component} from 'react';
import {Button, SIZE } from 'baseui/button';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid';
import * as ROUTES from '../Routes';

import logo_icon from '../images/enclock_1024x1024.png';

class Home extends Component {

    render = () => {
        return <div className="App">
            <header className="App-header">
                <FlexGrid flexGridRowGap="scale800">
                    <FlexGridItem><img alt={''} src={logo_icon} width={'96px'} style={{border: '1px solid gray', borderRadius: '10px'}}/></FlexGridItem>
                    <FlexGridItem><HeadingSmall style={{margin: 0}}>Welcome to EncLock!</HeadingSmall></FlexGridItem>
                    <FlexGridItem><ParagraphLarge style={{margin: 0}}>Latest news: EncLock 1.8 is now available for Desktop, Android, and iPhone!</ParagraphLarge></FlexGridItem>
                    <FlexGridItem><ParagraphLarge style={{margin: 0}}>Comming soon: EncLock 2.0 — sync your data across Desktop, Android, and iPhone!</ParagraphLarge></FlexGridItem>
                    <FlexGridItem><Button size={SIZE.default} $as={'a'} href={ROUTES.WALL}>Enter</Button></FlexGridItem>
                </FlexGrid>
            </header>
        </div>
    };
}

export default Home;